<template lang="html">
  <div v-if="documents.length" class="documents-section">
    <UAccordion
      type="multiple"
      :items="accordionItems"
      :ui="{
        content: 'p-4 pt-0',
        root: 'border border-neutral-400',
        label: 'py-2 px-4',
        trailingIcon: 'mr-4',
      }"
    >
      <template #content="{ item }">
        <div class="flex flex-col gap-2">
          <a
            v-for="document in item.documents"
            :key="document.id"
            :href="getDocumentUrl(document.id)"
            target="_blank"
            rel="noopener noreferrer"
            class="documents-section__card flex min-w-0 items-center gap-3 border border-neutral-400 p-3 transition-colors hover:bg-neutral-50"
          >
            <UIcon name="i-lucide-file" class="size-5 shrink-0 text-muted" />
            <span class="truncate">{{ documentName(document) }}</span>
          </a>
        </div>
      </template>
    </UAccordion>
  </div>
</template>

<script setup lang="ts">
import type { AccordionItem } from '@nuxt/ui'
import type { EntityRefOfString, ProductDto } from '@repo/api/web/models'

interface DocumentsAccordionItem extends AccordionItem {
  documents: EntityRefOfString[]
}

const props = defineProps<{
  value: ProductDto
}>()

const { support } = useResources()

const documents = computed(() => props.value.documents || [])

const accordionItems = computed<DocumentsAccordionItem[]>(() => {
  if (!documents.value.length) return []

  return [
    {
      label: 'Документы',
      value: 'documents',
      documents: documents.value,
    },
  ]
})

function getDocumentUrl(resourceId: string) {
  return support.getResourceUrl(resourceId)
}

function documentName(document: EntityRefOfString) {
  return document.displayName?.trim() || document.id
}
</script>
